import React from 'react';

type Props = {
  className?: string;
};

const AmericanExpressIcon: React.FC<Props> = ({ className }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 23" className={className}>
    <path
      fill="#006FCF"
      d="M22.535 22.47v-3.508h-2.667l-1.373-1.521-1.38 1.52H8.322v-7.088H5.482l3.52-7.98H12.4l1.212 2.734V3.893h4.202l.73 2.06.734-2.06h3.258V.326H.428V22.47h22.107zm-2.218-4.396h2.218L19.6 14.958l2.934-3.081h-2.183L18.54 13.86l-1.794-1.983h-2.218l2.916 3.098-2.916 3.1h2.156l1.821-2.002 1.812 2.001zm.519-3.114l1.699 1.81v-3.605l-1.7 1.795zm-9.887 1.68v-.965h3.49v-1.399h-3.49v-.965h3.579v-1.434H9.26v6.197h5.267V16.64h-3.58zm9.915-5.663h1.67V4.78h-2.598L18.55 8.64l-1.38-3.86h-2.642v6.197h1.67V6.64l1.591 4.338h1.485l1.591-4.347v4.347zm-8.237 0h1.9l-2.73-6.197H9.622l-2.73 6.197h1.855l.513-1.24h2.846l.521 1.24zm-1.104-2.63h-1.68l.84-2.026.84 2.027z"
    ></path>
  </svg>
);

export default AmericanExpressIcon;
